import React from 'react';
import Layout from '../components/Layout';

function Fixtures() {
  return (
    <Layout>
      <div>
        <h1>Super League Fixtures</h1>
      </div>
    </Layout>
  );
}

export default Fixtures;
